/**
 * @description: HDD购买渲染券包裹组件
 */
import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import {} from 'antd';
import {} from '@ant-design/icons';
import {} from '&/utils/common';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import BuyCoupons from '&/pages/rendering-voucher/components/buyCoupons';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

function BuyRenderingCouponsModal(props) {
    const { appStore, location } = props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const render = params.get('render');
    const from = params.get('from');

    usePreventDefault();

    const [renderingData, setRenderingData] = useState({});
    const [userInfo, setUserInfo] = useState({});
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (token) {
            appStore.setLoginData({ token }, false);
            setRenderingData(JSON.parse(render));
            await queryUserInfo();
            setVisible(true);
        }
    };

    const queryUserInfo = async () => {
        try {
            const res = await getUserInfo();
            setUserInfo(res.data);
            localStorage.setItem('HDDUserData', JSON.stringify(res.data));
        } catch (e) {}
    };

    const paySuccess = () => {
        try {
            const url = `${window.location.origin}/hdd/buySuccessModal`;
            const urlParams = `?token=${token}`;
            const sendData = {
                Url: `${url}${urlParams}`,
                Width: 280,
                Height: 242,
            };
            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } catch (e) {
            console.log(e);
        }
    };

    const closeHddModal = () => {
        if (from === 'hddStartPage') {
            const sendData = {
                Url: `${window.location.origin}/hdd/myRenderingCouponsModal?token=${token}`,
                Width: 1000,
                Height: 560,
            };

            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } else {
            window.external.DispatchFun('StartPage', 'CloseRender', '');
        }
    };

    const goBack = () => {
        try {
            const url = `${window.location.origin}/hdd/renderingCouponsList`;

            const urlParams = `?token=${token}${from ? `&from=${from}` : ''}`;

            const sendData = {
                Url: `${url}${urlParams}`,
                Width: from === 'hddStartPage' ? 1030 : 900,
                Height: from === 'hddStartPage' ? 752 : 634,
            };

            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } catch (e) {}
    };

    return (
        <div className="buy-rendering-coupons-modal">
            <BuyCoupons
                isHideClose={false} // 为了显示 close 按钮，改为false
                userInfo={userInfo}
                renderingData={renderingData}
                afterPay={paySuccess}
                visible={visible}
                hide={closeHddModal}
                isHDD={true}
                goBack={goBack}
            />
        </div>
    );
}
export default inject('appStore')(observer(BuyRenderingCouponsModal));
